module.exports = __webpack_public_path__ + "static/media/32-sunday-river.921d63e3.jpg";